import { DrawerFooter } from '@chakra-ui/react';

export const UiDrawerFooter = DrawerFooter;
